import React from 'react'

import LinkGlobalNtt from '@/components/link-global-ntt/link-global-ntt'
import MenuFooter from '@/components/navigation/menu-footer'
import MenuGlobal from '@/components/navigation/menu-global'
import MenuSocial from '@/components/navigation/menu-social'

import * as styles from './footer.module.scss'

type FooterProps = {
  showNavigation?: boolean
}

const Footer: React.FC<FooterProps> = ({ showNavigation = true }) => {
  return (
    <div>
      <footer className={styles.footerPage}>
        <div className={styles.boxFooter}>
          <div className="row pb-4">
            <div className="col-md-6 col-12">
              <img
                src="/media/header_logo.svg"
                alt="logo ntt data"
                width="160"
                height="40"
                loading="lazy"
              />
            </div>
          </div>
          <div className="row pl-3">
            <LinkGlobalNtt />
          </div>
          <div className="row">{showNavigation && <MenuFooter />}</div>
        </div>
        <div className={`${styles.footerLegal} ${styles.boxFooter}`}>
          <div className="row">
            <MenuGlobal />
          </div>
          <div className="row d-lg-flex justify-content-between">
            <div className={`${styles.blockFollow} col-12 col-lg-5`}>
              <MenuSocial />
            </div>
            <div className="col-12 col-lg-5 text-lg-end">
              <ul>
                <li>© Copyright NTT DATA Corporation</li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
